/**
 * CorrectionsModal — Batch #14.331 : journal des corrections (annulations de report d'une pièce dont l'écriture était au grand livre).
 */
import { useEffect, useState } from "react";
import { api } from "@/api";
import { Empty, Modal, money, useGlBase } from "./_shared";

export default function CorrectionsModal({ onClose }) {
  const base = useGlBase();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`${base}/corrections`).then((r) => setRows(r.data?.items || [])).catch(() => setRows([])); }, [base]);
  return (
    <Modal title="Journal des corrections" sub="Pièces dont le report a été annulé alors que l'écriture était déjà au grand livre — motif obligatoire, écriture annulée (trace conservée)." onClose={onClose} wide testId="corrections-modal">
      {rows === null ? <p className="text-sm text-slate-500">Chargement…</p> : !rows.length ? <Empty>Aucune correction enregistrée.</Empty> : (
        <div className="overflow-x-auto border rounded-xl">
          <table className="w-full text-xs" data-testid="corrections-table">
            <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500"><tr><th className="text-left px-3 py-2">Quand</th><th className="text-left px-2 py-2">Pièce</th><th className="text-left px-2 py-2">Date pièce</th><th className="text-right px-2 py-2">Montant</th><th className="text-left px-2 py-2">Écriture annulée</th><th className="text-left px-2 py-2">Motif</th><th className="text-left px-2 py-2">Par</th></tr></thead>
            <tbody className="divide-y">
              {rows.map((c) => (
                <tr key={c.id} data-testid={`correction-row-${c.id}`}>
                  <td className="px-3 py-1.5 font-mono whitespace-nowrap">{String(c.at || "").slice(0, 16).replace("T", " ")}</td>
                  <td className="px-2 py-1.5">{c.label} <span className="font-mono">{c.doc_number}</span></td>
                  <td className="px-2 py-1.5 font-mono">{c.doc_date}</td>
                  <td className="px-2 py-1.5 text-right font-mono">{money(c.amount || 0)}</td>
                  <td className="px-2 py-1.5">{c.entry_no ? `n° ${c.entry_no}` : "—"}</td>
                  <td className="px-2 py-1.5 max-w-xs">{c.reason}</td>
                  <td className="px-2 py-1.5 text-slate-500">{c.by}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  );
}
